/**
 * Helpers compartidos del sistema de límites duty-free (11 categorías, fuente:
 * Excel del cliente). Usado por product-form.js (capa 2, PDP) y
 * cart-pickup-data.js (capas 1 y 3, carrito) para no duplicar la clasificación
 * de categoría ni el parseo de ml en cada archivo.
 */
(function () {
  var CATEGORY_MATCHERS = [
    ['licores', function (pt) { return pt.indexOf('licor') !== -1; }],
    ['habanos', function (pt) { return pt.indexOf('habano') !== -1; }],
    ['cigarrillos', function (pt) { return pt.indexOf('cigarrillo') !== -1 || pt.indexOf('cigarro') !== -1; }],
    ['tabaco', function (pt) { return pt.indexOf('tabaco') !== -1; }],
    ['fragancias', function (pt) { return pt.indexOf('fragancia') !== -1 || pt.indexOf('parfum') !== -1; }],
    ['cremas', function (pt) { return pt.indexOf('crema') !== -1; }],
    ['lociones', function (pt) { return pt.indexOf('locion') !== -1 || pt.indexOf('loción') !== -1; }],
    ['splash', function (pt) { return pt.indexOf('splash') !== -1; }],
    ['tv', function (pt) { return pt.indexOf('televisor') !== -1; }],
    ['celulares', function (pt) { return pt.indexOf('celular') !== -1; }],
    ['relojes', function (pt) { return pt.indexOf('inteligente') !== -1; }],
  ];

  function productTypeToDutyFreeCategory(productType) {
    if (!productType) return null;
    var pt = String(productType).toLowerCase().trim();
    for (var i = 0; i < CATEGORY_MATCHERS.length; i++) {
      if (CATEGORY_MATCHERS[i][1](pt)) return CATEGORY_MATCHERS[i][0];
    }
    return null;
  }

  /**
   * Extrae el volumen en ml de un texto de variante (ej: "750 ml", "1000 ml / Rojo").
   * @returns {number} ml, o 0 si no se puede determinar
   */
  function parseDutyFreeMl(str) {
    if (!str) return 0;
    var m = String(str).match(/(\d+(?:[.,]\d+)?)\s*ml\b/i);
    if (m) return Math.round(parseFloat(m[1].replace(',', '.'))) || 0;
    return 0;
  }

  // Todas las categorías se miden vía metacampo custom.* dedicado — nunca campos
  // nativos de Shopify (weight/weight_unit, price, etc.), aunque parezcan encajar.
  var VOLUME_CATEGORIES = { licores: true, fragancias: true, cremas: true, lociones: true, splash: true };
  var METAFIELD_UNIT_CATEGORIES = { cigarrillos: true, habanos: true };
  // custom.libras_duty_free: sin fallback, sin default "1" (a diferencia de
  // cigarrillos/habanos) — si no está seteado, esa variante no cuenta hacia el
  // límite en vez de asumir 1 libra, que sería un falso bloqueo con datos vacíos.
  var WEIGHT_CATEGORIES = { tabaco: true };

  var cachedConfig = null;
  /**
   * Lee y cachea #duty-free-limits-config: { [categoria]: { tipo, limite } }.
   */
  function getConfig() {
    if (cachedConfig) return cachedConfig;
    var el = document.getElementById('duty-free-limits-config');
    if (!el) return null;
    try {
      cachedConfig = JSON.parse(el.textContent);
      return cachedConfig;
    } catch (_) {
      return null;
    }
  }

  window.DutyFreeHelpers = {
    productTypeToDutyFreeCategory: productTypeToDutyFreeCategory,
    parseDutyFreeMl: parseDutyFreeMl,
    getConfig: getConfig,
    VOLUME_CATEGORIES: VOLUME_CATEGORIES,
    METAFIELD_UNIT_CATEGORIES: METAFIELD_UNIT_CATEGORIES,
    WEIGHT_CATEGORIES: WEIGHT_CATEGORIES,
  };
})();
